/**
 * @desc 查询是否需要刷新我得NFTs
 */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/user/selectNewDataFlag', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/user/selectNewDataFlag', params);
}
